import { digFeatures } from '@/mocks/home';
import SectionHeading from '@/components/feature/SectionHeading';

export default function DigFeatures() {
  const [lead, ...rest] = digFeatures;

  return (
    <section id="dig" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="DEEP DIVE"
          title="事件深扒 · 头条"
          desc="不追热点，只挖脉络。每篇深扒都附上信源与推理过程，让你自己判断哪一步站得住。"
          actionHref="#archive"
          actionLabel="配套实锤档案"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <article className="lg:col-span-7 group">
            <a href="#archive" className="block">
              <div className="relative w-full h-[260px] md:h-[400px] rounded-lg overflow-hidden bg-background-200">
                <img
                  src={lead.image}
                  alt={lead.title}
                  title={`${lead.title} · 18爆料网事件深扒`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <span className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  {lead.tag}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                  <h3 className="font-heading font-bold text-background-50 text-xl md:text-3xl leading-snug">
                    {lead.title}
                  </h3>
                </div>
              </div>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed line-clamp-2">
                {lead.summary}
              </p>
              <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                <span>{lead.author}</span>
                <span>{lead.date}</span>
                <span>阅读 {lead.readTime}</span>
                <span className="text-primary-600 font-medium">{lead.views} 阅读</span>
              </div>
            </a>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-6">
            {rest.map((item) => (
              <article key={item.id} className="group">
                <a href="#archive" className="flex gap-4">
                  <div className="w-32 md:w-40 h-[104px] md:h-[128px] shrink-0 rounded-lg overflow-hidden bg-background-200">
                    <img
                      src={item.image}
                      alt={item.title}
                      title={`${item.title} · 18爆料网事件深扒`}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-col justify-between min-w-0 py-0.5">
                    <div>
                      <span className="inline-block px-2 py-0.5 rounded text-[11px] font-medium bg-accent-100 text-accent-900">
                        {item.tag}
                      </span>
                      <h3 className="mt-2 font-heading font-semibold text-base md:text-lg text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {item.title}
                      </h3>
                    </div>
                    <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 hidden sm:block">
                      {item.summary}
                    </p>
                    <span className="mt-2 text-xs text-foreground-400">
                      {item.author} · {item.readTime}
                    </span>
                  </div>
                </a>
              </article>
            ))}

            <a
              href="#ranking"
              className="mt-auto flex items-center justify-between gap-3 p-4 rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              <span className="text-sm font-medium">深扒合辑：已更新 18 篇，按事件归档</span>
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-lg" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}